import React from 'react';

const Logo = ({ isScrolled = false, size = 'md' }) => {
    const sizes = {
        sm: {
            topText: 'text-[8px] px-2',
            mainText: 'text-3xl',
            bottomText: 'text-[7px] px-2',
            letterSpacing: 'tracking-[0.2em]',
            mainTextMargin: 'my-0', // AJUSTE AQUI
        },
        md: {
            topText: 'text-[10px] px-3 py-0.5',
            mainText: 'text-5xl',
            bottomText: 'text-[9px] px-3 py-0.5',
            letterSpacing: 'tracking-[0.25em]',
            mainTextMargin: 'my-0', // AJUSTE AQUI
        },
        lg: {
            topText: 'text-xs px-4 py-1',
            mainText: 'text-6xl',
            bottomText: 'text-[10px] px-4 py-1',
            letterSpacing: 'tracking-[0.3em]',
            mainTextMargin: 'my-0', // AJUSTE AQUI
        }
    };

    const currentSize = sizes[size];

    return (
        <img
            src="/logoMevam.png"
            alt="Logo MEVAM"
            className="object-contain h-16 md:h-20 w-auto"
            style={{ maxWidth: '280px' }}
        />
    );
};

export default Logo;